import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { BreadCrumb, SearchInput } from '../../models/components';
import { AppState } from '../../models/state';
import { StateService } from '../../services/state.service';
import { SearchItemHelperService } from '../../services/helpers/search-item-helper.service';
import { DoctorCentersHelperService } from '../../services/helpers/doctor-centers-helper.service';
import { GoogleMapService } from '../../services/google-map.service';
import { UtilsService } from '../../services/utils.service';
import { UiService } from '../../services/ui.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-search-item',
  templateUrl: './search-item.component.html',
  styleUrls: ['./search-item.component.scss']
})
export class SearchItemComponent implements OnInit, OnDestroy {
  @ViewChild('searchItem') eleRef: ElementRef;


  @Output() onScrolling: EventEmitter<boolean>;
  @Input() input: Partial<SearchInput>;
  @Input() viewMap: boolean;
  @Input() index: number;

  @Input() virtualScroll: CdkVirtualScrollViewport;

  state: Partial<AppState>;
  subs: Subscription;

  constructor(
    public utils: UtilsService,
    public medicalCenterHelper: DoctorCentersHelperService,
    public googleMapService: GoogleMapService,
    private searchItemHelper: SearchItemHelperService,
    private ui: UiService,
    private stateService: StateService
  ) {
    this.onScrolling = new EventEmitter();
    this.subs = new Subscription();
    this.input = {};
    this.viewMap = true;
  }

  ngOnInit(): void {
    this.subs.add(
      this.stateService.getState().subscribe(state => {
        this.state = state;
      })
    );

    this.subs.add(this.googleMapService.scrollTo().subscribe((index) => {

      if (index === this.index) {
        this.onScrolling.emit(true);
        this.scrollToEleRef();
        this.ui.stopSpinner();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onMoreInfo() {
    this.searchItemHelper.onMoreInfo(this.state, this.input);
  }

  private scrollToEleRef() {
    const targetElement = this.eleRef.nativeElement;
    if (this.index !== 0) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    } else this.virtualScroll?.scrollToIndex(0);
  }


}

